import { HtmlRenderer } from "@repo/mfe-core";
import { ModalIsland, Typography } from "@saviynt/design-system";
import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";

interface TicketingSystemModalProps {
  subtitle: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export default function TicketingSystemModal({
  subtitle,
  isOpen,
  setIsOpen,
}: TicketingSystemModalProps) {
  const intl = useIntl();

  return (
    <ModalIsland
      kind="question"
      HeaderComp={
        <>
          <Typography kind="h2" className="text-center">
            {intl.formatMessage({
              description: "Modal Title",
              defaultMessage: "Connect Your Ticketing System",
              id: "aA5p+v",
            })}
          </Typography>
          <Typography kind="body2" className="text-center">
            <HtmlRenderer htmlString={subtitle} />
          </Typography>
        </>
      }
      onClose={() => setIsOpen(false)}
      isOpen={isOpen}
      isOutsideClickEnabled
      dataTestId="NHI-Detailed-Findings-ticketing-system-modal"
    />
  );
}
